import React from 'react'
import LoveCompatibility from './service_com_1'
import DescriptionSection from './service_com_2'
import AboutSection from '../../Components/TopHeader/topheader'
import './Servicepage.css'
export default function Servicepage() {
  return (
    <div className="servicepage-main-container">
  <AboutSection
  title="Service"
  description="Discover how the stars shape your relationship. Get a detailed compatibility analysis revealing emotional, mental, and spiritual harmony between you and your partner."
/>
<div className="main-container-subpart">

<div className="service-page-main-image-div">
    <img src="/assets/joinusbanner.png" alt="" className="servicepage-main-direct-image" />
</div>

<LoveCompatibility />
<DescriptionSection />


</div>


    </div>
  )
}
